import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "react-toastify/dist/ReactToastify.css";

import "./assets/styles/reset.css";
import "./assets/styles/style.css";

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
